// @ts-nocheck
import { updateRemoteParticipantsSorting } from 'jitsi/filmstrip/actions.web';
import AbstractVideoTrack from 'jitsi/base/media/components/AbstractVideoTrack';
import { trackVideoStarted } from 'jitsi/base/tracks/actions.any';
export default class IISightAbstractVideoTrack extends AbstractVideoTrack {
    _onVideoPlaying() {
        const { videoTrack, dispatch } = this.props;
        if (videoTrack && !videoTrack.videoStarted) {
            dispatch(trackVideoStarted(videoTrack.jitsiTrack));
            dispatch(updateRemoteParticipantsSorting(videoTrack.jitsiTrack));
        }
    }
}
export * from 'jitsi/base/media/components/AbstractVideoTrack';
